import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgNutnix = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-nutnix';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M17.3 6.903a545 545 0 0 0-2.25 2.536l-.131.154.545.491c.396.356.559.48.598.453s3.903-4.359 4.443-4.98c.049-.056-.01-.121-.486-.54a13 13 0 0 0-.57-.487c-.016-.005-.983 1.063-2.149 2.373M3.99 5.01c-.487.377-.573.46-.535.512.025.035 1.166 1.506 2.537 3.27L8.483 12l-2.491 3.208a1368 1368 0 0 0-2.538 3.271c-.04.054.04.131.531.512.317.247.59.448.606.447.051-.004 5.746-7.375 5.746-7.438 0-.06-5.693-7.434-5.742-7.438-.014-.001-.287.201-.605.448m4.23-.007c-.308.241-.555.457-.55.479s1.136 1.489 2.51 3.26c1.375 1.771 2.5 3.237 2.5 3.258s-1.121 1.483-2.492 3.249a759 759 0 0 0-2.519 3.255c-.029.049 1.11.953 1.162.922.058-.036 5.749-7.387 5.749-7.426 0-.05-5.735-7.441-5.772-7.438-.016.001-.28.199-.588.441m7.228 8.923c-.477.434-.526.49-.474.549 1.951 2.207 4.441 4.985 4.467 4.985.02 0 .28-.215.578-.477.476-.419.535-.484.486-.54-.902-1.037-4.443-4.985-4.477-4.992-.026-.004-.287.209-.58.475"
    })
  }));
});
export default SvgNutnix;